import React from "react";
import { motion } from "framer-motion";

const ServiceCard = React.memo(({ service, isEven, animations }) => (
  <motion.div
    initial="initial"
    whileInView="animate"
    viewport={{ once: true, amount: 0.2, margin: "-50px" }}
    className="relative"
  >
    <motion.div
      variants={animations.scaleIn}
      className="absolute mt-[120px] md:mt-[160px] left-[calc(50%-20px)] md:left-[calc(50%-23.5px)] -translate-y-1/2 z-10"
    >
      <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-white flex items-center justify-center text-primary text-lg md:text-xl font-bold">
        {service.id}
      </div>
    </motion.div>

    <div className="grid grid-cols-2 gap-4 md:gap-8">
      <motion.div variants={animations.fadeInUp} className="pr-8 md:pr-16">
        {isEven ? (
          <div className="bg-white/10 backdrop-blur p-3 md:p-4 rounded-lg">
            <img
              src={service.image}
              alt={service.title}
              className="w-full rounded-lg"
              loading="lazy"
            />
          </div>
        ) : (
          <div className="space-y-3 md:space-y-4 text-white">
            <h3 className="text-lg md:text-2xl font-bold leading-tight">
              {service.title}
            </h3>
            <p className="text-sm md:text-lg leading-relaxed">
              {service.description}
            </p>
          </div>
        )}
      </motion.div>
      <motion.div variants={animations.fadeInUp} className="pl-8 md:pl-16">
        {isEven ? (
          <div className="space-y-3 md:space-y-4 text-white">
            <h3 className="text-lg md:text-2xl font-bold leading-tight">
              {service.title}
            </h3>
            <p className="text-sm md:text-lg leading-relaxed">
              {service.description}
            </p>
          </div>
        ) : (
          <div className="bg-white/10 backdrop-blur p-3 md:p-4 rounded-lg">
            <img
              src={service.image}
              alt={service.title}
              className="w-full rounded-lg"
              loading="lazy"
            />
          </div>
        )}
      </motion.div>
    </div>
  </motion.div>
));

ServiceCard.displayName = "ServiceCard";

export default ServiceCard;
